<mat-card class="breadcrumb">
    <div class="row">
        <div class="col-md-7">
            <!--<a [routerLink]="['/dashboard']">Dashboard</a>-->
            <!--<mat-icon>arrow_forward_ios</mat-icon>-->
            <a *ngIf="isNew" [routerLink]="['/rateplans']">Create Rate Plan</a>
            <a *ngIf="!isNew" [routerLink]="['/rateplans']">Edit Rate Plan</a>
        </div>
        <div class="col-md-5 text-right">
        </div>
    </div>
</mat-card>


    <div class="row" *ngIf="data">
        <div class="col-6">
            <mat-card class="mt-3">
            <h3 class="mat-title mb-1 mt-3">Room Raccoon specific</h3>

            <p>The rate plan code and name will be used to map the room selection to Room Raccoon rates</p>

            <mat-form-field class="example-full-width">
                <input matInput [(ngModel)]="data.ratePlanCode" placeholder="Plan Code">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <input matInput [(ngModel)]="data.name" placeholder="Plan Name">
            </mat-form-field>


            <div class="row">
                <div class="col-6">
                    <mat-form-field style="display: block">
                        <mat-select
                                matTooltip="The hotel that this rate applies to"
                                [(ngModel)]="data.hotel"
                                (ngModelChange)="getRooms(true)"
                                placeholder="Hotel">
                            <mat-option [value]="hotel.id" *ngFor="let hotel of hotels">{{hotel.name}}</mat-option>
                        </mat-select>
                        <mat-hint>The hotel that this rate applies to</mat-hint>
                    </mat-form-field>
                </div>

                <div class="col-6">

                    <mat-form-field style="display: block">
                        <mat-select
                                [(ngModel)]="data.isDerivative"
                                placeholder="Derivative rate?">
                            <mat-option [value]="1">Yes</mat-option>
                            <mat-option [value]="0">No</mat-option>
                        </mat-select>
                        <mat-hint>Is this rate a derivative?</mat-hint>
                    </mat-form-field>

                </div>

            </div>

            <div class="mt-3">
                <h3 class="mat-title mb-1 mt-3">Room selection</h3>
            </div>


            <p class="mb-1">Select the rooms this rate should be mapped to in Room Raccoon</p>

            <p class="mb-2">Room Raccoon will intermittently poll the data to sync this rate to the rooms selected</p>

            <p class="mb-1" style="font-style: italic; font-size: 12px;">Please note syncing may take several hours</p>


            <div class="mb-4 mt-1">

                <button
                    class="mr-2 mb-2"
                    *ngFor="let room of rooms"
                    mat-raised-button
                    [color]="isRoomSelected(room.id) > -1 ? 'primary' : 'grey'"
                    color="primary"
                    (click)="toggleRoom(room.id)">
                    {{room.name}}
                </button>

            </div>

            </mat-card>

<mat-card class="mt-3">

            <div class="row mb-3">
                <div class="col-4">
                    <mat-form-field style="display: block">
                        <mat-select
                                [(ngModel)]="data.status"
                                placeholder="Active?">
                            <mat-option [value]="1">Yes</mat-option>
                            <mat-option [value]="0">No</mat-option>
                        </mat-select>
                        <mat-hint>Show/hide rate in Booking Portal</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-4">
                </div>
                <div class="col-4">
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <mat-form-field style="display: block">
                        <mat-select
                                [(ngModel)]="data.allowOpenTable"
                                placeholder="Allow Open Table?">
                            <mat-option [value]="1">Yes</mat-option>
                            <mat-option [value]="0">No</mat-option>
                        </mat-select>
                        <mat-hint>Show Open Table in checkout process?</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field style="display: block">
                        <mat-select
                                [(ngModel)]="data.allowPassport"
                                placeholder="Allow passport discount?">
                            <mat-option [value]="1">Yes</mat-option>
                            <mat-option [value]="0">No</mat-option>
                        </mat-select>
                        <mat-hint>Allow passport discount for this rate?</mat-hint>
                    </mat-form-field>

                </div>


            </div>

            <div class="row mt-4 mb-3">
                <div class="col-6">
                    <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="data.planDiscount" placeholder="Plan discount (%)">
                        <mat-hint>Generally 0% if passport discount is allowed</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="data.planSurcharge" placeholder="Plan surcharge (£)">
                        <mat-hint>Add an amount to base rack rate value from Room Raccoon</mat-hint>
                    </mat-form-field>
                </div>
            </div>




</mat-card>


<mat-card class="mt-3">
                <h3 class="mat-title">Additional nights configuration</h3>
            <div class="row mb-3">
                <div class="col-6">
                    <mat-form-field style="display: block">
                        <mat-select
                                [(ngModel)]="data.allowAdditionalNights"
                                placeholder="Allow additional nights?">
                            <mat-option [value]="1">Yes</mat-option>
                            <mat-option [value]="0">No</mat-option>
                        </mat-select>
                        <mat-hint>Allow additional nights?</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="data.additionalNightDiscount" placeholder="Additional night discount (%)">
                        <mat-hint>Discount percentage for the additional nights added?</mat-hint>
                    </mat-form-field>
                </div>
            </div>


            <div class=" mt-4 mb-4">
                <h3 class="mat-title">Additional nights popup title</h3>
                <div>
                    <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="data.additionalNightsTitle" placeholder="Additional nights title">
                    </mat-form-field>

                    <mat-hint class="mt-1" style="font-size: 12px;">This text is displayed in the additional nights modal</mat-hint>
                </div>
            </div>

            <div class="mb-4">
                <h3 class="mat-title">Additional nights popup subtitle</h3>
                <quill-editor [modules]="config" [(ngModel)]="data.additionalNightsSubtitle" [style]="{'height':'200px'}"></quill-editor>
                <div>
                    <mat-hint class="mt-1" style="font-size: 12px;">This text is displayed in the additional nights modal</mat-hint>
                </div>
            </div>


</mat-card>
        </div>
        <div class="col-6">
<mat-card class="mt-3">

            <h3 class="mat-title">Lead Banner Image</h3>
            <div class="row">
                <div class="col-md-4">
                    <img *ngIf="!data.bannerImage" src="/assets/images/nia.png" class="img-fluid" style="max-height: 150px" />
                    <img *ngIf="data.bannerImage" [src]="data.bannerImage" class="img-fluid" style="max-height: 150px" />
                </div>
                <div class="col-md-8">
                    <app-image-upload *ngIf="data.id" [ownerID]="data.id" [type]="'ratePlan'" [text]="'Click here to upload image'" (imageUploaded)="setEventBannerImage($event)"></app-image-upload>
                </div>
            </div>

            <div class="mb-3 mt-4">
                <h3 class="mat-title">Plan Overview</h3>
                <mat-form-field class="example-full-width">
                    <input matInput [(ngModel)]="data.overview" placeholder="Plan overview">
                    <mat-hint>This is displayed to the customer when choosing a rate on checkout. A short one-liner only.</mat-hint>
                </mat-form-field>
                <!-- <quill-editor [modules]="config" [(ngModel)]="data.overview" [style]="{'height':'200px'}"></quill-editor> -->
            </div>

            <div class="mb-3 mt-4">
                <h3 class="mat-title">Plan Description</h3>
                <quill-editor [modules]="config" [(ngModel)]="data.description" [style]="{'height':'200px'}"></quill-editor>
                <div>
                    <mat-hint class="mt-1" style="font-size: 12px;">This is displayed when a customer clicks the 'i' button and will popup to reveal full information.</mat-hint>
                </div>
            </div>


            <div class="mb-4">
                <h3 class="mat-title">Terms and Conditions</h3>
                <quill-editor [modules]="config" [(ngModel)]="data.terms" [style]="{'height':'200px'}"></quill-editor>
                <div>
                    <mat-hint class="mt-1" style="font-size: 12px;">These are displayed when a customer clicks the 'i' button and will popup to reveal full information.</mat-hint>
                </div>
            </div>

            <!-- <div class="mb-4">
                <h3 class="mat-title">Promo tile text</h3>
                <quill-editor [modules]="config" [(ngModel)]="data.upsellText" [style]="{'height':'200px'}"></quill-editor>
                <div>
                    <mat-hint class="mt-1" style="font-size: 12px;">This text is displayed when a customer searches 1 night and promo rates are available for 2.</mat-hint>
                </div>
            </div> -->

            <div class="mb-4">
                <h3 class="mat-title">Tile offer text</h3>
                <div>
                    <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="data.tileOfferText" placeholder="Tile offer text">
                    </mat-form-field>

                    <mat-hint class="mt-1" style="font-size: 12px;">This text is displayed on the promo tile</mat-hint>
                </div>
            </div>



</mat-card>

        </div>
    </div>




    <div class="text-right mb-4">
        <button mat-raised-button color="primary" (click)="save()">Save</button>
        <div class="text-danger mt-2" *ngIf="errorString">{{errorString}}</div>
    </div>

    <!-- <app-event-sku-edit *ngIf="dataToEdit" [data]="dataToEdit" (complete)="dataEditComplete($event)"></app-event-sku-edit> -->

